module.exports = __webpack_public_path__ + "static/media/img_talent_manager@2x.31cf2ccd.png";